// extracted by mini-css-extract-plugin
export default {"popupGrid":"TournamentsReport_popupGrid__TcN-W","popupGrid_row":"TournamentsReport_popupGrid_row__yaPZD","datesInput":"TournamentsReport_datesInput__Qoirm"};